module.exports = __webpack_public_path__ + "img/bear.7feec3a.png";